export const PhotoBox = ({ name, ratio = "aspect-[4/3]", testid }) => (
  <div
    className={`flex ${ratio} flex-col items-center justify-center gap-2 border border-dashed border-hairline bg-raised p-6 text-center`}
    data-testid={testid}
  >
    <span className="text-[0.625rem] uppercase tracking-[0.16em] text-sub">
      Photograph to be supplied
    </span>
    <span className="text-[0.5625rem] uppercase tracking-[0.16em] text-violet">
      {name}
    </span>
  </div>
);

export const PhotoSlot = ({ name, caption, ratio, testid }) => (
  <figure>
    <PhotoBox name={name} ratio={ratio} testid={testid} />
    {caption && (
      <figcaption className="mt-3 text-[0.625rem] uppercase tracking-[0.16em] text-sub">
        {caption}
      </figcaption>
    )}
  </figure>
);

export const RealPhoto = ({ src, alt, caption, testid, framed = true }) => (
  <figure>
    <div className={framed ? "photo-frame overflow-hidden border border-hairline bg-raised" : "overflow-hidden"}>
      <img src={src} alt={alt} loading="lazy" className="h-auto w-full" data-testid={testid} />
    </div>
    {caption && (
      <figcaption className="mt-3 text-[0.625rem] uppercase tracking-[0.16em] text-sub">
        {caption}
      </figcaption>
    )}
  </figure>
);
